// @flow
/* eslint-disable no-use-before-define */

export type VehicleType = $Values<typeof VEHICLE_TYPE>
export type VehicleTypeName = $Keys<typeof VEHICLE_TYPE>

const VEHICLE_TYPE = {
  // Cars
  SHARED_RIDE: 1,
  PRIVATE_VAN: 2,
  SEDAN: 3,
  SUV: 4,
  LIMO: 5,
  LOCAL_DRIVER: 8,
  TAXI: 9,
  MINICAB: 11,
  MOTOTAXI: 13,
  SHARED_TAXI: 15,
  ALL_INCLUSIVE_VAN: 102,
  ALL_INCLUSIVE_SEDAN: 103,
  ALL_INCLUSIVE_SUV: 104,
  ALL_INCLUSIVE_LIMO: 105,
  ALL_INCLUSIVE_TAXI: 107,
  ALL_INCLUSIVE_SHARED_RIDE: 108,

  // Buses
  PRIVATE_BUS: 6,
  AIRPORTER: 7,
  BUS: 21,
  ALL_INCLUSIVE_BUS: 106,

  // Ferries
  WATER_TAXI: 16,
  SHARED_WATER_TAXI: 17,
  WATER_SHUTTLE: 18,
  SHARED_WATER_SHUTTLE: 19,
  ALL_INCLUSIVE_WATER_TAXI: 109,

  // Rails
  EXPRESS_TRAIN: 10,

  // Airs
  HELICOPTER: 20,

  // Public train
  TRAIN: 22,

  // Walk
  WALK: 99999,

  // Only defined client-side
  UNKNOWN: -1,
}

export default VEHICLE_TYPE
